let flexibleTextInputPromise: Promise<typeof import('./FlexibleTextInput/FlexibleTextInput')> | null = null;
let contentEditablePromise: Promise<typeof import('./ContentEditable/ContentEditable')> | null = null;

export function loadFlexibleTextInput() {
  if (!flexibleTextInputPromise) {
    flexibleTextInputPromise = import('./FlexibleTextInput/FlexibleTextInput');
  }
  return flexibleTextInputPromise;
}

export function loadContentEditable() {
  if (!contentEditablePromise) {
    contentEditablePromise = import('./ContentEditable/ContentEditable');
  }
  return contentEditablePromise;
}

export function preloadEditor() {
  return Promise.all([loadFlexibleTextInput(), loadContentEditable()]);
}
